import { useTranslation } from "react-i18next";

const PROTECTED_PREFIXES = [
  "/dashboard", "/forms", "/wizard", "/roadmaps",
  "/checklists", "/deadlines", "/documents", "/timeline", "/profile",
];

export function useLocalePath() {
  const { i18n } = useTranslation();

  return (path) => {
    const lang = i18n.language;
    if (!lang || lang === "en") return path;
    const isProtected = PROTECTED_PREFIXES.some(
      (p) => path === p || path.startsWith(p + "/") || path.startsWith(p + "?")
    );
    if (isProtected) return path;
    return `/${lang}${path}`;
  };
}
